import { TAB1_CAUSES, TAB2_PREVENTION, TAB3_PARCOURS } from "./premaData1";
import { TAB4_DEVELOPPEMENT, TAB5_MERE, TAB6_CONJOINT, TAB7_DEUIL } from "./premaData2";

export const PREMA_TABS = [
  { id: "causes", label: "Causes", intro: "Comprendre le « pourquoi », sans se blâmer.", fiches: TAB1_CAUSES },
  { id: "prevention", label: "Prévention", intro: "Les gestes de surveillance qui protègent.", fiches: TAB2_PREVENTION },
  { id: "parcours", label: "Parcours médical", intro: "De la réanimation au retour à la maison.", fiches: TAB3_PARCOURS },
  { id: "developpement", label: "Développement", intro: "Le suivi de l'enfant, mois après mois, année après année.", fiches: TAB4_DEVELOPPEMENT },
  { id: "mere", label: "La mère", intro: "Votre corps, vos émotions, vos droits.", fiches: TAB5_MERE },
  { id: "conjoint", label: "Le conjoint", intro: "La place et les émotions du co-parent.", fiches: TAB6_CONJOINT },
  { id: "deuil", label: "Deuil périnatal", intro: "Un espace dédié, traité avec une immense douceur.", fiches: TAB7_DEUIL },
];

export const PREMA_BY_ID = {};
PREMA_TABS.forEach((t) =>
  t.fiches.forEach((f) => {
    PREMA_BY_ID[f.id] = { ...f, tab: t.id, tabLabel: t.label };
  })
);

export const PREMA_TAB_COLOR = "#7E70AE";
